import { ReactNode } from "react"
import { twMerge } from "tailwind-merge"

interface LayoutProps {
  children: ReactNode
  className?: string
  as?: "main" | "div"
}

export default function Layout({
  children,
  className,
  as: Component = "main",
}: LayoutProps) {
  return (
    <Component
      className={twMerge(
        "custom-container flex min-h-dvh flex-col gap-16 pt-8 pb-14",
        className,
      )}
    >
      {children}
    </Component>
  )
}
